Shopify.queryParams = {};
if (location.search.length) {
	for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
		aKeyValue = aCouples[i].split('=');
		if (aKeyValue.length > 1) {
			Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
		}
	}
}

$(function() {

	$("#mobile-directory_toggle").click(function()
	{
		$("body").toggleClass("sitewide-push-left");
		$("#mobile-directory").toggleClass("sitewide-push-left");
		$("#mobile-directory_toggle i").toggleClass("fa-bars").toggleClass("fa-times");
	});

	$("#mobile-search_toggle").click(function() {
		$("#mobile-search").toggleClass("hidden");
		$("#mobile-search_toggle").toggleClass("active");
	});
  
	$('#variants').change(function() {
		location.reload();
	});
  
	$('.selector-wrapper').addClass("form-group").removeClass("selector-wrapper");
	$('.single-option-selector').addClass("txt txt-small").removeClass("single-option-selector");

});